import React, { useState } from "react";
import "../../styles/services.css";

const Services = () => {
  const services = [
    {
      title: "Custom Software Development",
      description: "Tailored software solutions built with cutting-edge technologies to transform your business ideas into powerful, scalable applications.",
      category: "Development",
    },
    {
      title: "Website Development",
      description: "Creating stunning, responsive websites using modern frameworks like React and Next.js, focusing on performance and user experience.",
      category: "Development",
    },
    {
      title: "Mobile App Development",
      description: "Native and cross-platform mobile apps built with React Native and Flutter, delivering seamless experiences across iOS and Android.",
      category: "Development",
    },
    {
      title: "Web App Development",
      description: "Dynamic, feature-rich web applications engineered with modern tech stacks for optimal performance.",
      category: "Development",
    },
    {
      title: "IT Consulting",
      description: "Strategic technology guidance to optimize your digital transformation journey and maximize ROI on tech investments.",
      category: "Consulting",
    },
    {
      title: "Cloud Solutions",
      description: "Expert cloud architecture and deployment using AWS, Azure, or GCP, ensuring scalability and reliability for your applications.",
      category: "Consulting",
    },
    {
      title: "Data Analytics & AI",
      description: "Leverage machine learning and advanced analytics to transform your data into actionable business intelligence.",
      category: "Innovation",
    },
    {
      title: "Search Engine Optimization",
      description: "Data-driven SEO strategies to improve your digital presence and drive organic growth through targeted optimization.",
      category: "Marketing",
    },
    {
      title: "Application Development",
      description: "End-to-end application development with focus on scalability, security, and exceptional user experience.",
      category: "Development",
    },
    {
      title: "Accessibility Compliance",
      description: "WCAG-compliant development ensuring your digital products are accessible to all users while maintaining aesthetic appeal.",
      category: "Consulting",
    },
    {
      title: "Project Takeovers",
      description: "Expert handling of existing projects with smooth transition and optimization of current codebases and architectures.",
      category: "Consulting",
    },
    {
      title: "Software Maintenance",
      description: "Comprehensive maintenance and support services ensuring your applications remain secure, updated, and optimized.",
      category: "Support",
    }
  ];

  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div className="services-wrapper">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1 className="services-hero-title">Innovative Digital Solutions</h1>
          <p className="services-hero-description">
            Transforming your vision into reality with cutting-edge technology and personalized service.
          </p>
          <button className="services-hero-cta">Get Started</button>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="services-section-title">Our Expertise</h2>
          <div className="row g-4">
            {services.map((service, index) => (
              <div
                className="col-lg-4 col-md-6"
                key={index}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className={`service-card ${hoveredCard === index ? 'service-card-hover' : ''}`}>
                  <div className="service-card-category">{service.category}</div>
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-description">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 col-6 mb-4">
              <div className="stat-card">
                <h3 className="stat-value">12+</h3>
                <p className="stat-label">Services Offered</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-4">
              <div className="stat-card">
                <h3 className="stat-value">50+</h3>
                <p className="stat-label">Projects Completed</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-4">
              <div className="stat-card">
                <h3 className="stat-value">15+</h3>
                <p className="stat-label">Technologies Mastered</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-4">
              <div className="stat-card">
                <h3 className="stat-value">24/7</h3>
                <p className="stat-label">Support Available</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container text-center">
          <h2 className="cta-title">Ready to Transform Your Business?</h2>
          <p className="cta-description">Let’s collaborate to build the future of your digital presence.</p>
          <button className="cta-button">Contact Us Now</button>
        </div>
      </section>
    </div>
  );
};

export default Services;
